export default __webpack_public_path__ + "static/media/bg_2.0cfdefd1.svg";